module.exports = __webpack_public_path__ + "static/MobileTransparentBook-8a41d1ffdc8216095d0f9e6791c4ef15.png";